class AlgoliaIconRadioChecked extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconRadioCheckedUrl: this.getAttribute('default-icon-radio-checked-url'),
      iconRadioCheckedSize: this.getAttribute('icon-radio-checked-size'),
      iconRadioCheckedUrl: this.getAttribute('icon-radio-checked-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .icon-radio-checked {
        background-image: url(${this.settings.iconRadioCheckedUrl ? this.settings.iconRadioCheckedUrl : this.settings.defaultIconRadioCheckedUrl});
        background-position: center;
        background-repeat: no-repeat;
        background-size: ${this.settings.iconRadioCheckedSize}%;
        height: 100%;
        width: 100%;
      }
    `
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the icon content.
   * @returns {Array[HTMLElement]} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('icon-radio-checked');
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('focusable', 'false');
    div.textContent = ' ';
    
    return [style, div];
  }
}

customElements.define("algolia-icon-radio-checked", AlgoliaIconRadioChecked);